import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbTooltipModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { ClickOutsideModule } from 'ng-click-outside';

import { UIModule } from '../shared/ui/ui.module';
import { EventService } from '../core/services/event.service';

import { LayoutComponent } from './layout.component';
import { MenuComponent } from './shared/menu/menu.component';
import { TopbarComponent } from './shared/topbar/topbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { GridMenuComponent } from './shared/grid-menu/grid-menu.component';
import { TopbarSearchComponent } from './shared/topbar-search/topbar-search.component';

@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [LayoutComponent, MenuComponent, TopbarComponent, FooterComponent, FooterComponent, GridMenuComponent, TopbarSearchComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbCollapseModule,
    ClickOutsideModule,
    UIModule
  ],
  exports: [TopbarComponent, MenuComponent, FooterComponent],
  providers: [EventService]
})
export class LayoutModule { }
